// extracted by mini-css-extract-plugin
export default {"statsBox":"statsBox_statsBox__T4d4e","iconWrapper":"statsBox_iconWrapper__-IyIh"};